import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {Transaction} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name transactionDataService
 * @module portaro.uc.user
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing user transactions
 */
export default class TransactionDataService {
    public static readonly serviceName = 'transactionDataService';
    public static readonly ROUTE = 'transactions';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async query(ownerId: number): Promise<Transaction[]> {
        return this.Restangular
            .one(TransactionDataService.ROUTE)
            .get<Transaction[]>({owner: ownerId});
    }

    // eslint-disable-next-line @typescript-eslint/require-await
    @ngAsync()
    @unRestangularize()
    public async remove(transactionId: number): Promise<void> {
        this.Restangular
            .one(TransactionDataService.ROUTE, transactionId)
            .remove();
    }
}
